import Success from 'features/auth/resetPassword/screens/Success/Success';
import React from 'react';

export default function Page() {
  return <Success />;
}
